<template>
  <div>
    <div
      class="row align-items-center"
      :title="toolTip"
    >
      <div
        class="mr-1"
        :class="badgeClass"
      >
        {{ badge }}
      </div>
      <div class="content-heading">
        {{ goalName }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TicketTabHeader',
  props: {
    toolTip: {
      type: String,
      default: ''
    },
    badgeClass: {
      type: String,
      default: ''
    },
    badge: {
      type: String,
      default: ''
    },
    goalName: {
      type: String,
      default: ''
    }
  }
}
</script>
